import { useState, useEffect } from "react";
import clsx from 'clsx'
import { useIntl } from 'react-intl';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import { ICnae } from "../../interfaces/ICnae";
import CnaeService from "../../services/CnaeService";
import Swal from 'sweetalert2';
import CnaeModal from "./CnaeModal";
import CnaeImportarModal from "./CnaeImportarModal";
import CnaeTabela from "./CnaeTabela";

function Cnae() {

  const intl = useIntl();
  const { classes } = useLayout();
  const [cnaes, setCnaes] = useState<ICnae[]>([]);
  const [modalTitle, setModalTitle] = useState<string>('');
  const [showModal, setShowModal] = useState<boolean>(false);
  const [cnaeSelecionada, setCnaeSelecionada] = useState<ICnae>({} as ICnae);
  const [importarShowModal, setImportarShowModal] = useState<boolean>(false);
  const [paginaCarregada, setPaginaCarregada] = useState<boolean>(false);
  const columns = [
    {
      name: 'Código',
      selector: (row: ICnae) => row['codigo'],
      sortable: true
    },
    {
      name: 'Descrição',
      selector: (row: ICnae) => row['descricao'],
      sortable: true
    },
    {
      name: 'Ações',
      cell: (row: ICnae) => <AcoesCnae excluirCnae={excluirCnae} editarCnae={(cnae: ICnae) => {
        setModalTitle('Editar CNAE');
        setCnaeSelecionada(cnae);
        toggleModal();
      }} cnae={row} />
    }
  ];

  useEffect(() => {
    setTimeout(() => {
      carregarInformacoes();
    }, 1000)
  }, []);

  async function carregarInformacoes() {
    setPaginaCarregada(false);  
    await CnaeService.obterTodos(x => setCnaes(x));
    setPaginaCarregada(true);
  }

  function AcoesCnae({ cnae, excluirCnae, editarCnae }: { cnae: ICnae, excluirCnae: (cnae: ICnae) => void, editarCnae: (Cnae: ICnae) => void }) {
    return <div data-tag="allowRowEvents">
      <i onClick={() => editarCnae(cnae)} className="fas fa-edit fs-1" style={{ color: '#5E6397', fontWeight: 'normal', cursor: 'pointer' }}/>
      <i onClick={() => excluirCnae(cnae)} className="fas fa-trash-alt fs-1" style={{ color: '#5E6397', marginLeft: '20px', fontWeight: 'normal', cursor: 'pointer' }}/>
    </div>
  }

  function toggleModal(recarregarInformacoes?: boolean): void {
    if (recarregarInformacoes) {
      carregarInformacoes();
    }

    setShowModal(!showModal);

    if (showModal) {
      setTimeout(() => { 
        setCnaeSelecionada({} as ICnae)
      }, 300)
    }
  }

  function importarToggleModal(recarregarInformacoes?: boolean): void {
    if (recarregarInformacoes) {
      carregarInformacoes();
    }

    setImportarShowModal(!importarShowModal);

    if (importarShowModal) {
      setTimeout(() => {
        setCnaeSelecionada({} as ICnae)
      }, 300)
    }
  }

  async function excluirCnae(evento: ICnae) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-modal-excluir ms-5',
        cancelButton: 'btn btn-modal-cancelar'
      },
      buttonsStyling: false
    });
    const result = await swalWithBootstrapButtons.fire({
        title: 'Excluir CNAE',
        text: `Você realmente deseja excluir essa CNAE?`,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: `Excluir`,
        reverseButtons: true
    });

    if (result.isConfirmed) {
      await CnaeService.excluir(evento.id, () => setCnaes(cnaes.filter(e => e.id !== evento.id)), 'CNAE excluído com sucesso');
    }
  }

  return <>
    <PageTitle breadcrumbs={[]}>{ intl.formatMessage({ id: 'MENU.CNAE' }) }</PageTitle>
    <div className='toolbar' id='kt_toolbar'>
      <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
        <DefaultTitle />
        <CnaeImportarModal cnae={cnaeSelecionada} show={importarShowModal} toggleModal={importarToggleModal} />
        <CnaeModal cnae={cnaeSelecionada} title={modalTitle} show={showModal} toggleModal={toggleModal} />
        <div className='d-flex align-items-center py-1'>
          <button onClick={() => setImportarShowModal(true)} className='btn btn-sm btn-primario' style={{marginLeft: '330px', marginRight: '10px'}}>
            <i className="icon-lg text-white fas fa-upload"></i>
            <span style={{ verticalAlign: 'middle' }}> IMPORTAR </span>
          </button>
          <button onClick={() => {
            setModalTitle('Adicionar CNAE');
            setCnaeSelecionada({} as ICnae);
            toggleModal();
          }} className='btn btn-sm btn-primario'>
            <i className="icon-lg text-white fas fa-plus"></i>
            <span style={{ verticalAlign: 'middle' }}> CNAES </span>
          </button>
        </div>
      </div>
    </div>
    
    { paginaCarregada ? <CnaeTabela colunas={columns} itens={cnaes} /> : <p>Carregando...</p> }
  </>
};

export default Cnae;